import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { FilingsService } from '../filings.service';

interface Type {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrls: ['./sub-header.component.scss']
})
export class SubHeaderComponent {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource = [];
  sliderValue = 1;
  labelValue = '10K';
  sorts: Type[] = [
    { value: 'Latest Buys', viewValue: 'Latest Buys' },
    { value: 'Highest Last Week', viewValue: 'Highest Last Week' }
  ];
  relationships: Type[] = [
    { value: '10% Owner', viewValue: '10% Owner' },
    { value: 'All', viewValue: 'All' }
  ];
  selectedSort = 'Latest Buys';
  selectedRelationship = 'All';
  relations;

  constructor(private filingsService: FilingsService) { }

  getLabelValue(value?: number) {
    let val;

    if (value) {
      val = value;
    } else {
      val = this.sliderValue;
    }

    let result;
    switch (val) {
      case 1:
        result = '10k';
        break;
      case 2:
        result = '100k';
        break;
      case 3:
        result = '500k';
        break;
      case 4:
        result = '1M';
        break;
      case 5:
        result = '10M';
        break;
    }

    return '>' + result;
  }

  onSliderChange(e) {
    this.filingsService.onTotalValueSliderChanged(e.value);
  }

  sortSelected(e) {
    this.filingsService.updateQuery('sort', e.value);
  }

  relationshipSelected(e) {
    this.filingsService.updateQuery('relation', e.value);
  }
}
